<template>
<Dialog type="rule" :show="$bus.rule.show" :title="$bus.transify['COMMON_RULE']">
  <template v-slot:dialog-content>
    <div class="rule-content" v-html="$bus.rule.content" ref="ruleContent">
    </div>
  </template>
</Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    Dialog
  },
  watch: {
    '$bus.rule.show': {
      handler (current) {
        if (!current) {
          this.$refs.ruleContent.scrollTop = 0
        }
      }
    }
  }
}
</script>
<style lang="scss">
.rule-content {
  font-style: italic !important;
  @include px2res(font-size, 20);
  color: #fff !important;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  @include px2res(padding, 0, 26);
  font-family: Arial, Helvetica, sans-serif !important;
}

.rule-content h1,
.rule-content h2,
.rule-content h3,
.rule-content h4,
.rule-content h5,
.rule-content h6 {
  @include px2res(font-size, 36);
  color: #FFDF00 !important;
  line-height: 1.6em;
  font-style: italic !important;

}
.rule-content p,
.rule-content span,
.rule-content a,
.rule-content em {
  font-family: Arial, Helvetica, sans-serif !important;
  color: #fff !important;
  font-weight: inherit !important;
  line-height: 1.6em;
  font-style: italic !important;
}
.rule-content img {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/rule/index.vue